interface ActionTypes {
  SAVE_USER_PROFILE_START: string;
  SAVE_USER_PROFILE_SUCCESS: string;
  SAVE_USER_PROFILE_FAILURE: string;
  REQUEST_USER_LINKING_START: string;
  REQUEST_USER_LINKING_SUCCESS: string;
  REQUEST_USER_LINKING_FAILURE: string;
  VERIFY_USER_LINKING_START: string;
  VERIFY_USER_LINKING_SUCCESS: string;
  VERIFY_USER_LINKING_FAILURE: string;
  CONFIRM_USER_LINKING_START: string;
  CONFIRM_USER_LINKING_SUCCESS: string;
  CONFIRM_USER_LINKING_FAILURE: string;
  SET_EMAIL_LINKING_START: string;
  SET_EMAIL_LINKING_SUCCESS: string;
  SET_EMAIL_LINKING_FAILURE: string;
  IMPORT_ENQUIRIES_START: string;
  IMPORT_ENQUIRIES_SUCCESS: string;
  IMPORT_ENQUIRIES_FAILURE: string;
  FETCH_IMPORT_ENQUIRIES_STATUS_START: string;
  FETCH_IMPORT_ENQUIRIES_STATUS_SUCCESS: string;
  FETCH_IMPORT_ENQUIRIES_STATUS_FAILURE: string;
}

export const OnboardingActionTypes: ActionTypes = {
  SAVE_USER_PROFILE_START: '@@SAVE_USER_PROFILE_START',
  SAVE_USER_PROFILE_SUCCESS: '@@SAVE_USER_PROFILE_SUCCESS',
  SAVE_USER_PROFILE_FAILURE: '@@SAVE_USER_PROFILE_FAILURE',
  REQUEST_USER_LINKING_START: '@@REQUEST_USER_LINKING_START',
  REQUEST_USER_LINKING_SUCCESS: '@@REQUEST_USER_LINKING_SUCCESS',
  REQUEST_USER_LINKING_FAILURE: '@@REQUEST_USER_LINKING_FAILURE',
  VERIFY_USER_LINKING_START: '@@VERIFY_USER_LINKING_START',
  VERIFY_USER_LINKING_SUCCESS: '@@VERIFY_USER_LINKING_SUCCESS',
  VERIFY_USER_LINKING_FAILURE: '@@VERIFY_USER_LINKING_FAILURE',
  CONFIRM_USER_LINKING_START: '@@CONFIRM_USER_LINKING_START',
  CONFIRM_USER_LINKING_SUCCESS: '@@CONFIRM_USER_LINKING_SUCCESS',
  CONFIRM_USER_LINKING_FAILURE: '@@CONFIRM_USER_LINKING_FAILURE',
  SET_EMAIL_LINKING_START: '@@SET_EMAIL_LINKING_START',
  SET_EMAIL_LINKING_SUCCESS: '@@SET_EMAIL_LINKING_SUCCESS',
  SET_EMAIL_LINKING_FAILURE: '@@SET_EMAIL_LINKING_FAILURE',
  IMPORT_ENQUIRIES_START: '@@IMPORT_ENQUIRIES_START',
  IMPORT_ENQUIRIES_SUCCESS: '@@IMPORT_ENQUIRIES_SUCCESS',
  IMPORT_ENQUIRIES_FAILURE: '@@IMPORT_ENQUIRIES_FAILURE',
  FETCH_IMPORT_ENQUIRIES_STATUS_START: '@@FETCH_IMPORT_ENQUIRIES_STATUS_START',
  FETCH_IMPORT_ENQUIRIES_STATUS_SUCCESS:
    '@@FETCH_IMPORT_ENQUIRIES_STATUS_SUCCESS',
  FETCH_IMPORT_ENQUIRIES_STATUS_FAILURE:
    '@@FETCH_IMPORT_ENQUIRIES_STATUS_FAILURE'
};

export interface OnboardingState {
  saveUserProfileResponse?: any;
  isSavingUserProfile?: boolean;
  saveUserProfileError?: any;
  requestUserLinkingResponse?: any;
  isRequestingUserLinking?: boolean;
  requestUserLinkingError?: any;
  verifyUserLinkingResponse?: any;
  isVerifyingUserLinking?: boolean;
  verifyUserLinkingError?: any;
  confirmUserLinkingResponse?: any;
  isConfirmingUserLinking?: boolean;
  confirmUserLinkingError?: any;
  setEmailLinkingResponse?: any;
  isSetEmailLinking?: boolean;
  setEmailLinkingError?: any;
  importEnquiriesResponse?: any;
  isImportingEnquiries?: boolean;
  importEnquiriesError?: any;
  fetchImportEnquiriesStatus?: any;
  isFetchingImportEnquiriesStatus?: boolean;
}

export interface ProfileFormValues {
  companyName: string;
  contactPhoneNumber: string;
  jobTitle: string;
  industry: string;
  companySize: string;
  estimatedEnquiries: string;
  isTrialUser: boolean;
}

export interface ElevenHundredDetailsFormValues {
  codes: string;
}
